// @ts-nocheck
// This file is generated by Umi automatically
// DO NOT CHANGE IT MANUALLY!
import model_1 from '/Users/lk/github/freelogfe-web-repos/packages/console/src/models/__template';
import model_2 from '/Users/lk/github/freelogfe-web-repos/packages/console/src/models/collectionCreatorPage/index';
import model_3 from '/Users/lk/github/freelogfe-web-repos/packages/console/src/models/collectionDetailPage';
import model_4 from '/Users/lk/github/freelogfe-web-repos/packages/console/src/models/collectionExhibitInfoPage/index';
import model_5 from '/Users/lk/github/freelogfe-web-repos/packages/console/src/models/collectionListPage';
import model_6 from '/Users/lk/github/freelogfe-web-repos/packages/console/src/models/collectionManager/index';
import model_7 from '/Users/lk/github/freelogfe-web-repos/packages/console/src/models/createdCollectionExhibitInfoPage';
import model_8 from '/Users/lk/github/freelogfe-web-repos/packages/console/src/models/dashboardPage';
import model_9 from '/Users/lk/github/freelogfe-web-repos/packages/console/src/models/discoverPage';
import model_10 from '/Users/lk/github/freelogfe-web-repos/packages/console/src/models/exhibitInfoPage';
import model_11 from '/Users/lk/github/freelogfe-web-repos/packages/console/src/models/global';
import model_12 from '/Users/lk/github/freelogfe-web-repos/packages/console/src/models/globalSearching';
import model_13 from '/Users/lk/github/freelogfe-web-repos/packages/console/src/models/informalNodeManagerPage/index';
import model_14 from '/Users/lk/github/freelogfe-web-repos/packages/console/src/models/informExhibitInfoPage/index';
import model_15 from '/Users/lk/github/freelogfe-web-repos/packages/console/src/models/nodeCreatorPage';
import model_16 from '/Users/lk/github/freelogfe-web-repos/packages/console/src/models/nodeManager_Contract_Page';
import model_17 from '/Users/lk/github/freelogfe-web-repos/packages/console/src/models/nodeManagerPage/index';
import model_18 from '/Users/lk/github/freelogfe-web-repos/packages/console/src/models/nodes';
import model_19 from '/Users/lk/github/freelogfe-web-repos/packages/console/src/models/resourceAuthPage';
import model_20 from '/Users/lk/github/freelogfe-web-repos/packages/console/src/models/resourceCollectPage';
import model_21 from '/Users/lk/github/freelogfe-web-repos/packages/console/src/models/resourceCreatorBatchPage';
import model_22 from '/Users/lk/github/freelogfe-web-repos/packages/console/src/models/resourceCreatorPage/index';
import model_23 from '/Users/lk/github/freelogfe-web-repos/packages/console/src/models/resourceDependencyPage';
import model_24 from '/Users/lk/github/freelogfe-web-repos/packages/console/src/models/resourceDetailPage';
import model_25 from '/Users/lk/github/freelogfe-web-repos/packages/console/src/models/resourceEditorPage';
import model_26 from '/Users/lk/github/freelogfe-web-repos/packages/console/src/models/resourceInfoPage';
import model_27 from '/Users/lk/github/freelogfe-web-repos/packages/console/src/models/resourceListPage';
import model_28 from '/Users/lk/github/freelogfe-web-repos/packages/console/src/models/resourceSider';
import model_29 from '/Users/lk/github/freelogfe-web-repos/packages/console/src/models/resourceVersionCreatorPage';
import model_30 from '/Users/lk/github/freelogfe-web-repos/packages/console/src/models/resourceVersionEditorPage';
import model_31 from '/Users/lk/github/freelogfe-web-repos/packages/console/src/models/storageHomePage';
import model_32 from '/Users/lk/github/freelogfe-web-repos/packages/console/src/models/storageObjectEditor';
import model_33 from '/Users/lk/github/freelogfe-web-repos/packages/console/src/models/user';

export const models = {
model_1: { namespace: '__template', model: model_1 },
model_2: { namespace: 'collectionCreatorPage.index', model: model_2 },
model_3: { namespace: 'collectionDetailPage', model: model_3 },
model_4: { namespace: 'collectionExhibitInfoPage.index', model: model_4 },
model_5: { namespace: 'collectionListPage', model: model_5 },
model_6: { namespace: 'collectionManager.index', model: model_6 },
model_7: { namespace: 'createdCollectionExhibitInfoPage', model: model_7 },
model_8: { namespace: 'dashboardPage', model: model_8 },
model_9: { namespace: 'discoverPage', model: model_9 },
model_10: { namespace: 'exhibitInfoPage', model: model_10 },
model_11: { namespace: 'global', model: model_11 },
model_12: { namespace: 'globalSearching', model: model_12 },
model_13: { namespace: 'informalNodeManagerPage.index', model: model_13 },
model_14: { namespace: 'informExhibitInfoPage.index', model: model_14 },
model_15: { namespace: 'nodeCreatorPage', model: model_15 },
model_16: { namespace: 'nodeManager_Contract_Page', model: model_16 },
model_17: { namespace: 'nodeManagerPage.index', model: model_17 },
model_18: { namespace: 'nodes', model: model_18 },
model_19: { namespace: 'resourceAuthPage', model: model_19 },
model_20: { namespace: 'resourceCollectPage', model: model_20 },
model_21: { namespace: 'resourceCreatorBatchPage', model: model_21 },
model_22: { namespace: 'resourceCreatorPage.index', model: model_22 },
model_23: { namespace: 'resourceDependencyPage', model: model_23 },
model_24: { namespace: 'resourceDetailPage', model: model_24 },
model_25: { namespace: 'resourceEditorPage', model: model_25 },
model_26: { namespace: 'resourceInfoPage', model: model_26 },
model_27: { namespace: 'resourceListPage', model: model_27 },
model_28: { namespace: 'resourceSider', model: model_28 },
model_29: { namespace: 'resourceVersionCreatorPage', model: model_29 },
model_30: { namespace: 'resourceVersionEditorPage', model: model_30 },
model_31: { namespace: 'storageHomePage', model: model_31 },
model_32: { namespace: 'storageObjectEditor', model: model_32 },
model_33: { namespace: 'user', model: model_33 },
} as const
